const postContent = $('.post__item');

// Check for existing ad blocks in content
if (postContent.length > 0 && postContent.find('.c-broadcast-space').length === 0 && $(window).width() <= 678) {
    const firstChild = postContent.find('> .user-content > *:first-child');
    const mpuTop = $('.sidebar-item--mpu-top');
    const mpuBottom = $('.sidebar-item--mpu-bottom');
    let childrenCount = postContent.find('> .user-content').children().length;
    let insertEl = postContent;

    // If there is only 2 children then append ads in to the first block, usually infers legacy content
    if (childrenCount <= 2 && firstChild.length >= 1) {
        childrenCount = firstChild.find('.user-content').children().length;
        insertEl = firstChild;
    }

    const mpuTopDivision = Math.floor(childrenCount / 4) >= 1 ? Math.floor(childrenCount / 4) : 1;
    const mpuTopTarget = insertEl.find(`> .user-content > *:nth-child(${mpuTopDivision})`);

    // Check for any rendered ads at the insertion point
    const checkForAdItem =
        mpuTopTarget.hasClass('broadcast-space__element') || mpuTopTarget.next().hasClass('broadcast-space__element');

    let mpuTopPosition = mpuTopDivision;

    // If the current position item is an ad, bump insertion after next element
    if (mpuTopTarget.hasClass('broadcast-space__element')) {
        mpuTopPosition = mpuTopPosition + 1;
    }

    // If the the next element after the current position item is an ad, bump insertion by 2 elements
    if (mpuTopTarget.next().hasClass('broadcast-space__element')) {
        mpuTopPosition = mpuTopPosition + 2;
    }

    const mpuBottomDivision = Math.ceil(childrenCount / 2);
    const mpuBottomPosition =
        mpuBottomDivision <= mpuTopPosition || mpuBottomDivision === mpuTopPosition + 1
            ? mpuBottomDivision + 1
            : mpuBottomDivision;

    mpuTop.insertAfter(insertEl.find(`> .user-content > *:nth-child(${mpuTopPosition})`));
    mpuBottom.insertAfter(insertEl.find(`> .user-content > *:nth-child(${mpuBottomPosition})`));
}
